module.exports = __webpack_public_path__ + "img/20171103_085358-min.4ee8d759.jpg";